import { jsx } from "react/jsx-runtime";
import { iconFactory } from "./Icon.js";
const IconView = iconFactory('IconView', /*#__PURE__*/ jsx("g", {
    fill: "none",
    children: /*#__PURE__*/ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 18c4.063 0 7.223-3.1 8.577-4.9.564-.7.564-1.6 0-2.3C19.223 9.1 16.063 6 12 6s-7.223 3.1-8.577 4.9c-.564.7-.564 1.6 0 2.2C4.777 14.9 7.937 18 12 18Zm0-9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3Z",
        fill: "none",
        "data-icon-type": "fill"
    })
}));
export { IconView };
